import { createContext } from 'react';

export interface CurrencyRates {
  [currency: string]: number;
}

export interface CurrencyApiResponse {
  rates: CurrencyRates;
  time_last_update_unix?: number;
}

export interface CurrencyRangeFormat {
  currency: string;
  min: string | null;
  max: string | null;
  label: string | null;
}

export interface CurrencyFormatOptions {
  currency?: string;
  minimumFractionDigits?: number;
  maximumFractionDigits?: number;
}

export interface CurrencyContextType {
  baseCurrency: string;
  selectedCurrency: string;
  setSelectedCurrency: (currencyCode: string) => void;
  rates: CurrencyRates;
  lastUpdated: number | null;
  loading: boolean;
  error: string | null;
  availableCurrencies: string[];
  convertAmount: (amountInUsd: number | null | undefined, currencyCode?: string) => number | null;
  formatAmount: (
    amountInUsd: number | null | undefined,
    options?: CurrencyFormatOptions
  ) => string | null;
  formatRange: (
    minUsd: number | null | undefined,
    maxUsd: number | null | undefined,
    options?: CurrencyFormatOptions
  ) => CurrencyRangeFormat | null;
  getRate: (currencyCode: string) => number | null;
}

export const CurrencyContext = createContext<CurrencyContextType | null>(null);
